export const skills = [
  {
    category: "Développement Web",
    icon: "💻",
    items: ["HTML5", "CSS3", "JavaScript", "React", "Tailwind CSS"]
  },
  {
    category: "Langages de Programmation",
    icon: "📝",
    items: ["Java", "C++", "Kotlin", "JavaScript", "SQL"]
  },
  {
    category: "Bases de Données",
    icon: "🗄️",
    items: ["MySQL"]
  },
  {
    category: "Outils & Technologies",
    icon: "🛠️",
    items: ["Git & GitHub", "Docker", "Linux", "Spring Boot", "Microsoft Azure (fondamentaux)", "Quartus Prime"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Application de gestion et de passation d'examens en ligne",
    description: "L'application permet aux enseignants de créer des examens en ligne avec différents paramètres et aux étudiants de passer ces examens et voir leurs résultats.",
    technologies: ["React", "Spring Boot", "Déploiement sur Azure"],
    github: "https://github.com/sibaguilavogui/Projet-Conception.git"
  }
];

export const experiences = [
  {
    id: 1,
    title: "Classes préparatoires en mathématiques et physique",
    company: "Lycée scientifique national de Ouagadougou",
    location: "Ouagadougou, Burkina Faso",
    period: "2021 - 2023",
    description: [
      "Formation scientifique intensive visant à développer chez les étudiants une forte capacité de raisonnement, d’analyse et de rigueur scientifique afin de les préparer aux études d'ingénierie."
    ]
  },
  {
    id: 2,
    title: "Baccalauréat en Génie Informatique",
    company: "Université du Québec à Chicoutimi",
    location: "Saguenay, Québec",
    period: "2023 - Présent",
    description: [
      "Formation approfondie en algorithmique et structures de données",
      "Cours en réseaux, bases de données et développement logiciel",
      "Projets pratiques en équipe"
    ]
  }
];

export const contactInfo = {
  email: "nyhien@etu.uqac.ca",
  phone: "+1 (418) 812-4143",
  location: "Saguenay, Québec",
  github: "https://github.com/17Yannick17",
  linkedin: "https://www.linkedin.com/in/yannick-hien-3a6187177"
};